export var dashboardTourSteps = [
    {
        element: 'h3.p-dashboard__summary-header',
        popover: {
            title: '期間総売上：選択中の期間の売上実績と見込みを確認できます',
            side: 'bottom'
        }
    },
    {
        element: 'h3.p-dashboard__monthly-sales-header-text',
        popover: {
            title: '月別グラフ：月ごとの売上・粗利率の推移をグラフで確認できます',
            side: 'bottom'
        }
    },
    {
        element: 'h3.p-dashboard__transition-sales-header-text',
        popover: {
            title: '推移グラフ：売上・粗利率の長期トレンドを確認できます',
            side: 'bottom'
        }
    },
    {
        element: 'h3.p-dashboard__scheduled-project-title',
        popover: {
            title: '計上予定案件：今後売上が計上される案件の一覧です。案件名をクリックすると詳細を確認できます',
            side: 'top'
        }
    }
];
